import { Component, inject, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import Article from 'src/smoothr-web-app-core/models/Article';
import { ModalController } from '@ionic/angular';
import { ShortInfoModalComponent } from '../short-info-modal/short-info-modal.component';

@Component({
	selector: 'app-tag',
	templateUrl: './tag.component.html',
	styleUrls: ['tag.component.scss'],
	standalone: false,
})
export class TagComponent {
	@Input() article: Article;
	@Input() iconSize: { width: number; height: number } = { width: 20, height: 20 };
	@Input() showTopSelling: boolean = false;
	environment = environment;

	private modalCtrl = inject(ModalController);
	constructor() {}

	showInfo(event: Event) {
		event.stopPropagation();
		ShortInfoModalComponent.show(this.modalCtrl, this.article);
	}
}
